<template lang="pug">
	.contacts-tab.flex-row.wrap.buttons-group
		.button-item
			DxButton(:elementAttr="{ class: 'font-small' }", :text="getCounted($tCaption('Registered'), totalRegistered)", stylingMode="text", @click="$emit('tab-change', 'registered')", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'registered' ? 'default' : 'normal'")
		.button-item
			DxButton(:elementAttr="{ class: 'font-small' }", :text="getCounted($tCaption('Invited'), totalInvited)", stylingMode="text", @click="$emit('tab-change', 'invited')", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'invited' ? 'default' : 'normal'")
		.button-item
			DxButton(:elementAttr="{ class: 'font-small' }", :text="getCounted($tCaption('Waiting for approval'), totalWaitingApproval)", stylingMode="text", @click="$emit('tab-change', 'waitingApprove')", :hoverStateEnabled="false", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab === 'waitingApprove' ? 'default' : 'normal'")
</template>

<script>
	import DxButton from 'devextreme-vue/button';

	export default {
		translationCategory: 'company.DetailContactsTabs',
		name: 'company-detail',
		props: ['totalRegistered', 'totalInvited', 'totalWaitingApproval', 'tab'],
		components: { DxButton },
		model: {
			event: 'tab-change',
			prop: 'tab'
		},
		methods: {
			getCounted(text, count) {
				if (!count) return text;
				return `${text} (${count})`;
			}
		}
	};
</script>
